import { render, staticRenderFns } from "./LifeQuality.vue?vue&type=template&id=b18d15b2&scoped=true&"
import script from "./LifeQuality.vue?vue&type=script&lang=js&"
export * from "./LifeQuality.vue?vue&type=script&lang=js&"
import style0 from "./LifeQuality.vue?vue&type=style&index=0&id=b18d15b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18d15b2",
  null
  
)

export default component.exports